import React from 'react';
import styled from 'styled-components/native';
import EncouragementView from '../../components/EncouragementView';
import { B } from '../../components/Typography';

const StyledContainer = styled.View`
  flex: 1;
  background-color: white;
  align-items: center;
  justify-content: center;
`;
const EncouragementViewExampleScreen: React.FC = () => {
  return (
    <StyledContainer>
      <B>Sing line text</B>
      <EncouragementView message='One week in, you’ve got this!' image='👩🏻‍🔬' />
      <B>Multi-line text</B>
      <EncouragementView
        message='Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...'
        image='👩🏻‍🔬'
      />
    </StyledContainer>
  );
};
export default EncouragementViewExampleScreen;
